// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('variant.overview', {
    controller: 'OverviewController as vm',
    parent: 'variant',
    url: '/overview',
    templateUrl: 'main/article/variant/overview/overview.tpl.html',
    data: { pageTitle: 'Overview' },
  });
};

class OverviewController {
  constructor($rootScope, variant) {
    'ngInject';

    this.variant = variant;
    this.article = variant.article;

    $rootScope.pageTitle = `${this.article.itemCode || ''} - Overview`;

    this.nodeGroup = {
      nodeXValues: this.article.nodeXValues,
      nodeYValues: this.article.nodeYValues,
    };
  }
}

angular
  .module('main.article.variant.overview', [])
  .config(config)
  .controller('OverviewController', OverviewController);
